// Skills.jsx

import React from 'react';
import './Skills.css';

const Skills = () => {
  const techStack = [
    'Kotlin', 'Jetpack Compose', 'Java', 'Python', 'MySql',
    'React', 'NodeJs', 'Android SDK', 'React Native', 'AI/ML', 'AJAX', 'Android Studio',
    'Jupyter', 'GitHub', 'Git', 'VS Code', 'Native Android ', 'Windows','Linux','HTML', 'CSS', 'JavaScript'
  ];

  const frames = [
    {
      id: 1,
      imageUrl: 'https://i.pinimg.com/564x/ae/b1/d6/aeb1d603b91bee3594c6ee69c29f5e0b.jpg',
      description: {
        line1: 'Name: GitHub_Cafe',
        line2: 'Tech: Figma App Prototype',
      },
      githubLink: 'https://www.figma.com/design/y9izG2oKxEJSW7bFCiwRty/GitHub-Cafe?node-id=0-1&t=04ltt0Tidv6cOqva-1'
    },
    {
      id: 2,
      imageUrl: 'https://i.pinimg.com/564x/5c/d4/da/5cd4da26f98d9ca6d2c120abff67b369.jpg',
      description: {
        line1: 'Name: Threads',
        line2: 'Tech: Kotlin Jetpack, Firebase',
      },
      githubLink: 'https://github.com/Aditys018/Threads'
    },
    {
      id: 3,
      imageUrl: 'https://i.pinimg.com/564x/49/4f/ff/494fffe58f50f19e8192ad4597004629.jpg',
      description: {
        line1: 'Name: Graph_Visualizer',
        line2: 'Tech:AJAX,CSS,PHP',
      },
      githubLink: 'https://github.com/Aditys018/web.ajax'
    },
    {
      id: 4,
      imageUrl: 'https://i.pinimg.com/736x/97/ee/08/97ee0806304562520de27c94d5ea23a4.jpg',
      description: {
        line1: 'Name: Flow_Fields',
        line2: 'Tech: JavaScript, p5.js',
      },
      githubLink: 'https://github.com/Aditys018/FlowFields'
    },
    {
      id: 5,
      imageUrl: 'https://i.pinimg.com/736x/6f/03/82/6f0382fd98373a6a38ae89f45a349131.jpg',
      description: {
        line1: 'Name:Music Streaming app',
        line2: 'Tech:Kotlin XML,Deezer API',
      },
      githubLink: 'https://github.com/Google-DSC-Android/GDSC_Android.dev_MusicApp'
    },
    {
      id: 6,
      imageUrl: 'https://i.pinimg.com/564x/d4/03/77/d403778359a6b455e785651a3205ece2.jpg',
      description: {
        line1: 'Name: GeTogether',
        line2: 'Tech: Figma_App_Prototype',
      },
      githubLink: 'https://www.figma.com/proto/cUjH5bACaYdhYfu6QHJDpA/Getogether?node-id=282-173&t=1mBPbXEwgXrRwhzL-1'
    },
    {
      id: 7,
      imageUrl: 'https://i.pinimg.com/736x/6f/48/5c/6f485c9b9a943bff347de6f7de1dc939.jpg',
      description: {
        line1: 'Name: SnakeXenzia',
        line2: 'Tech: Jetpack Kotlin,Coroutines',
      },
      githubLink: 'https://github.com/Aditys018/SnakeXenzia'
    },
    {
      id: 8,
      imageUrl: 'https://i.pinimg.com/564x/52/24/f2/5224f22fcfed1f519ff990e1f48afd4f.jpg',
      description: {
        line1: 'Name:CRUD Operations in Android',
        line2: 'Tech:Jetpack Kotlin, Firebase',
      },
      githubLink: 'https://github.com/Aditys018/CRUD_Realtime'
    },
    {
      id: 1,
      imageUrl: 'https://i.pinimg.com/564x/ae/b1/d6/aeb1d603b91bee3594c6ee69c29f5e0b.jpg',
      description: {
        line1: 'Name: GitHub_Cafe',
        line2: 'Tech: Figma App Prototype',
      },
      githubLink: 'https://www.figma.com/design/y9izG2oKxEJSW7bFCiwRty/GitHub-Cafe?node-id=0-1&t=04ltt0Tidv6cOqva-1'
    },
    {
      id: 2,
      imageUrl: 'https://i.pinimg.com/564x/5c/d4/da/5cd4da26f98d9ca6d2c120abff67b369.jpg',
      description: {
        line1: 'Name: Threads',
        line2: 'Tech: Kotlin Jetpack, Firebase',
      },
      githubLink: 'https://github.com/Aditys018/Threads'
    },
    {
      id: 3,
      imageUrl: 'https://i.pinimg.com/564x/49/4f/ff/494fffe58f50f19e8192ad4597004629.jpg',
      description: {
        line1: 'Name: Graph_Visualizer',
        line2: 'Tech:AJAX,CSS,PHP',
      },
      githubLink: 'https://github.com/Aditys018/web.ajax'
    },
    {
      id: 4,
      imageUrl: 'https://i.pinimg.com/736x/97/ee/08/97ee0806304562520de27c94d5ea23a4.jpg',
      description: {
        line1: 'Name: Flow_Fields',
        line2: 'Tech: JavaScript, p5.js',
      },
      githubLink: 'https://github.com/Aditys018/FlowFields'
    },
    {
      id: 5,
      imageUrl: 'https://i.pinimg.com/736x/6f/03/82/6f0382fd98373a6a38ae89f45a349131.jpg',
      description: {
        line1: 'Name:Music Streaming app',
        line2: 'Tech:Kotlin XML,Deezer API',
      },
      githubLink: 'https://github.com/Google-DSC-Android/GDSC_Android.dev_MusicApp'
    },
    {
      id: 6,
      imageUrl: 'https://i.pinimg.com/564x/d4/03/77/d403778359a6b455e785651a3205ece2.jpg',
      description: {
        line1: 'Name: GeTogether',
        line2: 'Tech: Figma_App_Prototype',
      },
      githubLink: 'https://www.figma.com/proto/cUjH5bACaYdhYfu6QHJDpA/Getogether?node-id=282-173&t=1mBPbXEwgXrRwhzL-1'
    },
    {
      id: 7,
      imageUrl: 'https://i.pinimg.com/736x/6f/48/5c/6f485c9b9a943bff347de6f7de1dc939.jpg',
      description: {
        line1: 'Name: SnakeXenzia',
        line2: 'Tech: Jetpack Kotlin,Coroutines',
      },
      githubLink: 'https://github.com/Aditys018/SnakeXenzia'
    },
    {
      id: 8,
      imageUrl: 'https://i.pinimg.com/564x/52/24/f2/5224f22fcfed1f519ff990e1f48afd4f.jpg',
      description: {
        line1: 'Name:CRUD Operations in Android',
        line2: 'Tech:Jetpack Kotlin, Firebase',
      },
      githubLink: 'https://github.com/Aditys018/CRUD_Realtime'
    },
    
    // Add more frames as needed
  ];

  return (
    <div className="skills-container">
      <h1>MINI PROJECTS AND TECHNICAL SKILLS</h1>
      <div className="marquee-container">
        <div className="marquee">
          <div className="marquee-content marquee-content-left">
            {frames.map((frame) => (
              <div key={frame.id} className="frame-box">
                <img src={frame.imageUrl} alt={`Frame ${frame.id}`} />
                <div className="frame-description">
                  <p>{frame.description.line1}</p>
                  <p>{frame.description.line2}</p>
                </div>
                <div className="demo-button">
                  <a href={frame.githubLink} target="_blank" rel="noopener noreferrer">DEMO</a>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="marquee">
          <div className="marquee-content marquee-content-left">
            {techStack.map((tech, index) => (
              <div key={index} className="box">{tech}</div>
            ))}
          </div>
        </div>
        <div className="marquee">
          <div className="marquee-content marquee-content-right">
            {techStack.map((tech, index) => (
              <div key={index} className="box">{tech}</div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Skills;
